// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3_G0C","errors":"Errors_errors__2ycaO"};